//COMPONENTI
import React from 'react';
import { Link } from 'react-router-dom';

interface ServiceProps {
    serviceId: number;
    service: Service;
}

interface Service {
    title: string;
    icon: React.ReactNode;
    description: string;
    link: string;
    label: string;
}

const ServiceCard: React.FC<ServiceProps> = ({ service }) => {

    return (
        <div className="col-12 col-sm-10 col-md-6 col-lg-4 mb-4 mb-lg-0">
            <div className="card-service p-4">
                <div className="icon-wrapper">
                    {service.icon}
                </div>
                <h4 className="mb-3">{service.title}</h4>
                <p className="mb-3">{service.description}</p>
                <Link className="btn btn-primary" to={service.link} title={service.label ?? ''}>
                    {service.label}
                </Link>
            </div>
        </div>
    )
}

export default ServiceCard;